import React from "react";
import logo from "/logo.svg";

const ReportPublicHeader: React.FC = () => {
  return (
    <header className="border-b border-gray-200">
      <nav
        className="mx-auto flex flex-col items-center justify-center lg:px-4 mb-4 mt-4 min-h-[2.75rem] max-h-[2.75rem]"
        aria-label="Global"
      >
        <div className="flex flex-col items-center ">
          <a href="#" className="">
            <img src={logo} alt="" className={"w-[55px] h-[55px] "} />
          </a>
          <p className="text-gray-700 text-[15px] text-center mt-[-3px]">
            The intuitive workspace for Philanthropic organizations
          </p>
        </div>
      </nav>
    </header>
  );
};

export default ReportPublicHeader;
